import UserProfile from "../../../entities/UserProfile";
import {createContext, useContext} from "react";

export const ProfileContext = createContext<UserProfile>({} as UserProfile);
export const useUserProfile = () => useContext(ProfileContext);
